export default __webpack_public_path__ + "static/media/product-page-2.db82b35b.png";